import { COLORS } from "../../utils/colors";
import ResizeTools from "./resizeTools";
import * as d3 from "d3";

const Resize = {
  lastWidth: 0,
  lastHeight: 0,
  processing: false,
  x: [],
  y: [],

  apply: function(g, node){
    if(node.readOnly)
      return

    let dot = this.getDotResize(node);

    g.append("path")
      .classed("resize", true)
      .classed("dot1", true)
      .attr("d", dot.d1)
      .attr("stroke", COLORS.OrangePentagro1)
      .attr("stroke-width", 1.5)
      .style("cursor", "nw-resize")
      .on("mouseover",  (event, node) => this.mouseOver(event, node))
      .on("mouseout",(event, node) => this.mouseOut(event, node))
      .call(this.setResize(node))

    g.append("path")
      .classed("resize", true)
      .classed("dot2", true)
      .attr("d", dot.d2)
      .attr("stroke", COLORS.OrangePentagro1)
      .attr("stroke-width", 1.5)
      .style("cursor", "nw-resize")
      .on("mouseover",  (event, node) => this.mouseOver(event, node))
      .on("mouseout",(event, node) => this.mouseOut(event, node))
      .call(this.setResize(node))

    g.append("path")
      .classed("resize", true)
      .classed("dot3", true)
      .attr("d", dot.d3)
      .attr("stroke", COLORS.OrangePentagro1)
      .attr("stroke-width", 1.5)
      .style("cursor", "nw-resize")
      .on("mouseover",  (event, node) => this.mouseOver(event, node))
      .on("mouseout",(event, node) => this.mouseOut(event, node))
      .call(this.setResize(node))
    
  },

  getDotResize: function(d){
    let dist1 = 7
    let dist2 = 4
    let dist3 = 1
    
    return {
      d1: `M${(d.x - dist1) + d.width},${d.y + d.height}L${d.x + d.width},${d.y - dist1 + d.height}`,
      d2: `M${(d.x - dist2) + d.width},${d.y + d.height}L${d.x + d.width},${d.y - dist2 + d.height}`,
      d3: `M${(d.x - dist3) + d.width},${d.y + d.height}L${d.x + d.width},${d.y - dist3 + d.height}`,
    }
  },
  
  createContour: function(node) {
    d3.select(`#${node.idName}`)
      .append('path')
      .classed("resize-contour", true)
      .attr("d", this.getPathContour())
      .attr("stroke", COLORS.OrangePentagro1)
      .attr("stroke-width", 1)
      .style("fill", "none")
      .node();
  },

  setResize: function(node) {
      if (node.readOnly) return d3.drag();

      this.setDimension(node)

      let that = this
      let drag = d3
          .drag()
          .on("drag", (event, node) => that.dragged(event, node))
          .on("end", (event, node) => that.dragended(event, node));

      return drag;
  },

  dragged: function (event, d) {
    if(!this.processing) {
      this.processing = true
      this.createContour(d)
    }

    this.move(d)
    this.expandX(event, d)
    this.expandY(event, d)

    this.changeContour(d);
  },

  dragended: function(event, d) {
    this.processing = false
    this.setDimension(d)
    this.kilPath(d)
  },

  expandX: function(event, d){
    d.width = event.x - (d.x - this.lastWidth)
    d.width = d.width < 20 ? 20 : d.width

    this.setContour(d)
    ResizeTools.expandX(d)
  },

  expandY: function(event, d){
    d.height = event.y - (d.y - this.lastHeight)
    d.height = d.height < 20 ? 20 : d.height

    this.setContour(d)
    ResizeTools.expandY(d)
  },

  setDimension: function(node){
    this.lastWidth = node.width;
    this.lastHeight = node.height
    this.setContour(node)
  },

  setContour(node){
    this.x[0] = node.x
    this.y[0] = node.y
    this.x[1] = node.x + node.width
    this.y[1] = node.y + node.height
  },

  getPathContour: function(){
    return `M${this.x[0]},${this.y[0]}L${this.x[1]},${this.y[0]}L${this.x[1]},${this.y[1]}L${this.x[0]},${this.y[1]}L${this.x[0]},${this.y[0]}`
  },

  changeContour: function(d){
    d3.select(`#${d.idName} > path.resize-contour`)
    .raise()
    .attr('d', this.getPathContour())
  },

  kilPath: function(node) {
    d3.select(`#${node.idName} > path.resize-contour`).remove()
  },

  mouseOver: function(event, d) {
    if(d.readOnly)
      return

    d3.selectAll(`#${d.idName} > path.resize`)
        .attr("stroke", COLORS.OrangePentagro1)
  },

  mouseOut: function(event, d) {
    if(d.readOnly)
      return

    d3.selectAll(`#${d.idName} > path.resize`)
        .attr("stroke", "#0000")
  },

  move: function (node) {
    if(node.readOnly)
      return

    d3.selectAll(`#${node.idName} > path.resize-contour`)
      .raise()
      .attr("d", this.getPathContour())

    let dot = this.getDotResize(node)

    d3.selectAll(`#${node.idName} > path.dot1`)
      .raise()
      .attr("d", dot.d1)

    d3.selectAll(`#${node.idName} > path.dot2`)
      .raise()
      .attr("d", dot.d2)
    
    d3.selectAll(`#${node.idName} > path.dot3`)
      .raise()
      .attr("d", dot.d3)
  },

}

export default Resize